<template>
  <div class="box">
    <ul v-if="list.length">
      <li v-for="(item, index) in list" :key="index" @click="jump(item)">
        {{ item.name }}
      </li>
    </ul>
    <div class="empty" v-else>
      <p>暂无讲义～</p>
    </div>
  </div>
</template>

<script>
import getToken from "@/utils/getToken";
export default {
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    // 设置页面title
    // 获取页面详情内容
    let that = this;
    const { course_id } = this.$route.query;
    this.$api.classes
      .getCourseCheckList({
        course_id: course_id ? course_id : "undefind",
        page: 1,
        page_size: 9999999,
      })
      .then((data) => {
        if (data.error_code === 0) {
          that.requestEnd = true;
          that.list = data.result.list;
        } else {
          // throw new Error('error')
        }
      });
  },
  methods: {
    /**
     * 点击列表项
     * courseware_type: 1 未来课件
     * is_pdf： true  直接打开pdf连接
     * 否则 打开教研云连接
     */
    async jump(item) {
      if (item.file_type === 1) {
        let token = await getToken();
        let url = `https://zkronghe1-app.test-dahai.com/qingwen/classroom/notes_list/des?id=${item.id}&teacher_id=${item.author_id}&token=${token}`;
        if (process.env.NODE_ENV == "production") {
          url = `https://app.xes1v1.com/qingwen/classroom/notes_list/des?id=${item.id}&teacher_id=${item.author_id}&token=${token}`;
        }
        window.location.href = url;
        return;
      } else {
        this.$api.classes
          .getCoursePreview({
            material_id: item.id,
            file_type: item.file_type,
            material_source: item.material_source,
            opt_type: 1,
            course_id: item.course_id,
          })
          .then((res) => {
            if (res.error_code === 0) {
              if (res.result.url != "") {
                let url =
                  item.file_ext === "mp3" || item.file_ext === "mp4"
                    ? res.result.url.split("&")[0]
                    : res.result.url;
                switch (item.file_ext) {
                  case "mp3":
                    this.$router.push({
                      path: "/note_audio",
                      query: { url: url, name: item.name },
                    });
                    break;
                  case "mp4":
                    this.$router.push({
                      path: "/note_video",
                      query: { url: url, name: item.name },
                    });
                    break;
                  default:
                    window.location.href = url;
                    break;
                }
              } else {
                this.$toast("资源不存在");
              }
            }
          });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.box {
  margin-top: 5px;
  ul li {
    height: 56px;
    background: url("../../assets/img/class/ico_arrowright.png") no-repeat 94%
      center;
    background-size: 10px 10px;
    border-bottom: 1px solid #eaeaea;
    font-size: 15px;
    color: #222222;
    margin-left: 18px;
    display: flex;
    align-items: center;
    padding-right: 20%;
    text-overflow: ellipsis;
    box-sizing: border-box;
    overflow: hidden;
  }
  .empty {
    background: url("../../assets/img/class/blankpage_jiangyi.png") no-repeat
      center center;
    background-size: 218px 110px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: calc(100vh);
    p {
      color: #999;
      font-size: 14px;
      text-align: center;
      margin-top: 125px;
    }
  }
}
</style>
